module.exports = __webpack_public_path__ + "static/media/Kakao_Chao_Escolhendo.d4bcb41d.jpg";